// extracted by mini-css-extract-plugin
export default {"btn":"RedBtnLarge_btn__1O-Yr","digit":"RedBtnLarge_digit__VsBwL"};